<template>
  <div>
    <md-layout md-column v-if="certificationProcess.status <= 6" key="syncInformations">
      <span class="md-title">SINCRONIZAR INFORMAÇÕES TEMPORARIAMENTE</span>
      <span class="md-caption">Este processo visa sincronizar as informações coletadas até o momento e liberar espaço para coletar mais.</span>
      <md-list v-if="syncStarted">
        <area-sync-list @areaSynced="handleAreaSync" v-for="area in certificationProcess.areas" :key="area.id" :area="area">
        </area-sync-list>
      </md-list>
      <md-button v-else class="md-accent md-raised" @click="startSync">Iniciar a Sincronização</md-button>
    </md-layout>
    <md-layout v-else md-column>
      <span class="md-title">SUCESSO!
        <b>{{blh.name}}</b>
      </span>
      <span class="md-title">DADOS TEMPORARIOS SINCRONIZADO COM SUCESSO!</span>
      <span class="md-caption">Agora você pode continuar com a captura de informações</span>
    </md-layout>
    <md-snackbar md-position="bottom center" ref="snackbar" :md-duration="Infinity">
      <span>Sem conexão com a internet, não é possível sincronizar.</span>
      <md-button class="md-accent" @click="createSyncWorkers()">Reiniciar</md-button>
    </md-snackbar>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import AreaSyncList from '@/components/AreaSyncList'
export default {
  name: 'sync-process',
  components: {
    'area-sync-list': AreaSyncList
  },
  computed: {
    ...mapState({
      'certificationProcess': state => state.certificationProcess,
      'blh': state => state.blh
    })
  },
  data () {
    return {
      areaSynced: [],
      syncStarted: false
    }
  },
  watch: {
    areaSynced: function (newList) {
      if (this.areaSynced.length === this.certificationProcess.areas.length) {
        this.FETCH_IMAGE(this.certificationProcess.blueprint).then(imgBlob => {
          // storage.child(`${this.blh.currentYear}/${this.blh.id}/${this.certificationProcess.blueprint}`).put(imgBlob).then(() => {
          //   this.SYNC_TEMP_PROCESS(this.certificationProcess)
          // })
        })
      }
    }
  },
  beforeMount () {
    this.FETCH_DATA()
    window.addEventListener('online', () => {
      this.handleConnectivityChange(true)
    })
    window.addEventListener('offline', () => {
      this.handleConnectivityChange(false)
    })
  },
  methods: {
    ...mapActions([
      'FETCH_DATA',
      'FETCH_IMAGE',
      'SYNC_TEMP_PROCESS'
    ]),
    handleAreaSync (areaId) {
      if (!this.areaSynced.find(function (id) { return id === areaId })) {
        this.areaSynced.push(areaId)
      }
    },
    handleConnectivityChange (status) {
      console.log('handleConnectiveChange:' + status)
      if (status) {
        this.$refs.snackbar.close()
        this.startSync()
      } else {
        this.syncStarted = false
        this.$refs.snackbar.open()
      }
    },
    startSync () {
      this.syncStarted = true
    }
  }
}
</script>
<style scoped>
.md-spinner {
  position: absolute;
  top: 50%;
  left: 28px;
  transform: translate(-50%, -50%);
}

.md-title {
  text-align: center;
}

.md-caption {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// SyncView.vue?52da6cc8